import styled from 'styled-components'
import * as BaseStyles from '../BaseStyles'

import redXIcon from '../../Icons/Normal/red-x-icon.png'

export const AlertBoxBGDiv = styled(BaseStyles.Div)`
    z-index: 3;
    position: absolute;
    top: 0rem;
    bottom: 0rem;
    left: 0rem;
    right: 0rem;
    background: linear-gradient(
        rgba(0, 0, 0, 0.7), 
        rgba(0, 0, 0, 0.7)
    );
    overflow: auto;
`

export const AlertBoxDiv = styled(BaseStyles.Div)`
    padding: 2rem;
    width:  100vw;
    height: 100vh;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
`

export const AlertBoxComponentsDiv = styled(BaseStyles.Div)`
    box-shadow:
    0 0px 3.8px rgba(0, 0, 0, 0.022),
    0 0px 8.3px rgba(0, 0, 0, 0.031),
    0 0px 14.9px rgba(0, 0, 0, 0.039),
    0 0px 30.5px rgba(0, 0, 0, 0.048),
    0 0px 104px rgba(0, 0, 0, 0.07)
    ;
    margin: auto;
    flex: 1 1 50rem;
    min-width: 30rem;
    max-width: 50rem;
    border-radius: 0.8rem;
    background-color: white;
    padding: 1.5rem;
`

export const AlertBoxContentsDiv = styled(BaseStyles.Div)`
    
`

export const AlertBoxTopDiv = styled(BaseStyles.Div)`
    
`

export const AlertBoxTitleDiv = styled(BaseStyles.Div)`
    float: left;
`

export const AlertBoxExitDiv = styled(BaseStyles.Div)`
    float: right;
`

export const AlertBoxPhraseDiv = styled(BaseStyles.Div)`
    padding: 5rem 0rem;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow-wrap: break-word;
    clear: both;
`

export const AlertBoxButtonsDiv = styled(BaseStyles.Div)`
    float: right;
    display: flex;
    align-items: center;
`

export const AlertBoxTitle = styled.h2`
    margin: 0;
    padding: 0;
    font-size: 2.4rem;
    color: black;
    white-space: initial;
`

export const AlertBoxPhrase = styled.p`
    margin: 0;
    padding: 0;
    font-size: 1.8rem;
    color: black;
    white-space: initial;
`

export const AlertBoxRedXButton = styled(BaseStyles.IconButton)`
    width: 2.5rem;
    height: 2.5rem;
    background-image: url(${redXIcon});
`

export const AlertBoxActionButton = styled.button`
    display: block;
    color: #4267B2;
    background-color: transparent;
    text-align: center;
    outline-style: none;
    margin: 0rem 0.2rem;
    padding: 1rem 1.2rem;
    font-size: 1.6rem;
    border: none;
    &:hover{
        background: #E8E8E8;
    }
`